import React from "react";
import "./Arrows.scss";

function Arrows({ score }) {
  return (
    <div className="arrows">
      <svg
        viewBox="0 0 14 14"
        className={
          score === "above" || score === "more"
            ? `arrows__arrow above`
            : `arrows__arrow`
        }
      >
        <path d="M12.0148 8.98535L14 7.00009L7 6.47695e-07L-3.05976e-07 7.00009L1.98523 8.98535L5.72376 5.24897L5.72376 14L8.27624 14L8.27624 5.24897L12.0148 8.98535Z" />
      </svg>

      <svg
        width="23"
        height="2"
        viewBox="0 0 23 2"
        className={score === "equal" ? `arrows__bar equal` : `arrows__bar`}
      >
        <rect width="23" height="2" />
      </svg>

      <svg
        viewBox="0 0 14 14"
        className={
          score === "below" || score === "less"
            ? `arrows__arrow below`
            : `arrows__arrow`
        }
      >
        <path d="M1.98523 5.01465L-1.25965e-06 6.99991L7 14L14 6.99991L12.0148 5.01465L8.27624 8.75103L8.27624 -2.50193e-07L5.72376 -3.61766e-07L5.72376 8.75103L1.98523 5.01465Z" />
      </svg>
      <p className="score">{score !== "null" ? score : `N/A`}</p>
    </div>
  );
}

export default Arrows;
